import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { IoDownloadOutline } from '../../node_modules/react-icons/io5/index.esm.js';
import { _cs } from '@togglecorp/fujs';
import Container from '../Container/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

function DropContainer(props) {
  const {
    className,
    children,
    onDrop,
    dropOverlayContainerClassName,
    dropOverlayContent = /*#__PURE__*/React.createElement(IoDownloadOutline, {
      className: styles.dropOverlayIcon
    }),
    draggedOverClassName,
    name,
    disabled,
    ...otherProps
  } = props;
  const [isBeingDraggedOver, setIsBeingDraggedOver] = React.useState(false);
  const dragEnterRef = React.useRef(0);
  const handleDragEnter = React.useCallback(() => {
    if (dragEnterRef.current === 0) {
      setIsBeingDraggedOver(true);
    }

    dragEnterRef.current += 1;
  }, [setIsBeingDraggedOver]);
  const handleDragLeave = React.useCallback(() => {
    dragEnterRef.current -= 1;

    if (dragEnterRef.current === 0) {
      setIsBeingDraggedOver(false);
    }
  }, [setIsBeingDraggedOver]);
  const handleDragOver = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleDrop = React.useCallback(e => {
    e.preventDefault();

    if (onDrop) {
      const data = e.dataTransfer.getData('text');

      try {
        const resolvedData = JSON.parse(data);

        if (resolvedData.$name === name) {
          onDrop(resolvedData);
        }
      } catch (exception) {
        console.error(exception);
      }
    }

    dragEnterRef.current = 0;
    setIsBeingDraggedOver(false);
  }, [setIsBeingDraggedOver, onDrop, name]);
  const containerElementProps = React.useMemo(() => !disabled ? {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop
  } : undefined, [handleDragEnter, handleDragLeave, handleDragOver, handleDrop, disabled]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, otherProps, {
    className: _cs(styles.dropContainer, className, isBeingDraggedOver && styles.draggedOver, isBeingDraggedOver && draggedOverClassName),
    containerElementProps: containerElementProps
  }), !disabled && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.dropOverlay, dropOverlayContainerClassName)
  }, dropOverlayContent), children);
}

var index = genericMemo(DropContainer);

export { index as default };
//# sourceMappingURL=index.js.map
